import LinkStatusCard from "../components/LinkStatus/LinkStatusCard";
import useAuthStore from "../stores/useAuthStore";

export default function withSignedInNotice(ComposedComponent) {
  function SignedInNotice(props) {
    const authenticated = useAuthStore((state) => state.authenticated);

    if (authenticated) return <LinkStatusCard linkStatus="signedIn" />;
    return <ComposedComponent {...props} />;
  }

  return SignedInNotice;
}
